import { useEffect, useState } from "react";
import { isNative } from "../lib/native";
import { showInterstitial } from "../lib/ads";

// 게이트 1 (헤아림 → 편지). 네이티브 = AdMob 전면. 웹 = 짧은 전환 플레이스홀더(실수익은 AdSense Auto ads).
export default function Ad({ onDone }: { onDone: () => void }) {
  const [closable, setClosable] = useState(false);
  const native = isNative();

  useEffect(() => {
    if (native) {
      let done = false;
      const guard = () => {
        if (done) return;
        done = true;
        onDone();
      };
      showInterstitial().finally(guard);
      return;
    }
    const c = setTimeout(() => setClosable(true), 1500);
    const d = setTimeout(onDone, 2700);
    return () => {
      clearTimeout(c);
      clearTimeout(d);
    };
  }, [native, onDone]);

  return (
    <div className="screen ad">
      <div className="ad-box">
        <div className="ad-label">Advertisement</div>
        <div className="ad-icon">▶</div>
        <div className="ad-sub">{native ? "AdMob" : "AdSense"}</div>
        {!native && closable && (
          <button className="ad-close" onClick={onDone}>
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
